export default __webpack_public_path__ + "static/media/temp-service.a26d8f77.svg";